import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

const TopicCard = ({ topic }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (!topic.comingSoon) {
      navigate(`/business-playbook/${topic.slug}`);
    }
  };

  return (
    <button
      onClick={handleClick}
      disabled={topic.comingSoon}
      className={`group w-full text-left p-6 bg-white rounded-lg border border-gray-200 transition-all ${
        topic.comingSoon
          ? 'cursor-not-allowed opacity-60'
          : 'hover:border-purple-300 hover:shadow-md cursor-pointer'
      }`}
    >
      {/* Icon */}
      <div className="text-3xl mb-3">{topic.icon}</div>

      {/* Title */}
      <h3 className="text-lg font-semibold text-gray-900 mb-2 flex items-center justify-between">
        {topic.title}
        {!topic.comingSoon && (
          <ChevronRight className="w-5 h-5 text-gray-400 group-hover:text-purple-600 transition-colors" />
        )}
      </h3>

      {/* Subtitle */}
      <p className="text-sm text-gray-600 mb-4">{topic.subtitle}</p>

      {/* Article count or Coming soon */}
      {topic.comingSoon ? (
        <span className="inline-block px-3 py-1 text-xs font-medium text-gray-500 bg-gray-100 rounded-full">
          Coming soon
        </span>
      ) : (
        <span className="text-xs text-gray-500">
          {topic.articleCount} {topic.articleCount === 1 ? 'article' : 'articles'}
        </span>
      )}
    </button>
  );
};

export default TopicCard;
